import script from "./WebGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./WebGuide.vue?vue&type=script&setup=true&lang=js"

import "./WebGuide.vue?vue&type=style&index=0&id=4da08e27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4da08e27"]])

export default __exports__